export const ONBOARD_PAGE_SUBHEADER = 'ONBOARD_PAGE_SUBHEADER';
